import { render, staticRenderFns } from "./OrganizationLayout.vue?vue&type=template&id=bde5f7f0"
import script from "./OrganizationLayout.vue?vue&type=script&lang=js"
export * from "./OrganizationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports